import { capitalizeFirstLetter } from '@utils/strings';

// Stored run data keys are snake_case (`employee_id`), flattened nested paths
// (`root__0__name`) or whatever the external API returned (`fullName`).
const labelFromKey = (key: string): string => {
  const spaced = key
    .replace(/__/g, ' ')
    .replace(/_/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ')
    .trim();
  if (!spaced) return key;
  return capitalizeFirstLetter(spaced.toLowerCase());
};

type StoredEntry = { key: string; label: string; value: unknown; text: string };

const toText = (value: unknown): string => {
  if (value == null) return '';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const storedDataEntries = (data: unknown): StoredEntry[] => {
  if (typeof data !== 'object' || data === null || Array.isArray(data)) return [];
  return Object.entries(data as Record<string, unknown>).map(([key, value]) => ({
    key,
    label: labelFromKey(key),
    value,
    text: toText(value),
  }));
};
